import { PresentationTemplate } from '../types';

export const MASTER_PRESENTATION_TEMPLATES_STORAGE_KEY = 'klydapp_master_presentation_templates';

export const DEFAULT_MASTER_PRESENTATION_TEMPLATES: PresentationTemplate[] = [
    {
        id: 'master-tpl-semanal',
        projectId: 'global',
        name: 'Reunión de Planificación Semanal',
        description: 'Plantilla base estándar con portada, planificación de la semana anterior (completa), avance gráfico anterior, compromisos de la semana actual y plano de avance gráfico proyectado.',
        category: 'semanal',
        isDefault: true,
        createdBy: 'ConstructOS / Administración',
        createdAt: '2026-01-01T00:00:00.000Z',
        updatedAt: '2026-01-01T00:00:00.000Z',
        slides: [
            // Slide 1: Portada Corporativa
            {
                id: 's-sem-1',
                order: 0,
                background: '#0f172a',
                widgets: [
                    {
                        id: 'w-sem-title',
                        type: 'text_block',
                        x: 5,
                        y: 20,
                        width: 90,
                        height: 25,
                        config: {
                            text: 'REUNIÓN DE PLANIFICACIÓN SEMANAL',
                            fontSize: 34,
                            fontWeight: 800,
                            color: '#ffffff',
                            textAlign: 'center',
                            subtitle: 'Revisión de Cumplimiento de Compromisos y Asignación Semanal Activa',
                        },
                    },
                    {
                        id: 'w-sem-kpis',
                        type: 'kpi_cards',
                        x: 10,
                        y: 52,
                        width: 80,
                        height: 35,
                        config: {},
                    },
                ],
            },
            // Slide 2: Planificación Anterior (Completa)
            {
                id: 's-sem-2',
                order: 1,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-sem-prev-full',
                        type: 'weekly_prev_full',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {
                            pageSize: 12,
                            pageIndex: 0,
                        },
                    },
                ],
            },
            // Slide 3: Avance Gráfico Anterior
            {
                id: 's-sem-3',
                order: 2,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-sem-prev-graphic',
                        type: 'graphic_progress_prev',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {},
                    },
                ],
            },
            // Slide 4: Planificación Actual (Compromisos de la semana en curso)
            {
                id: 's-sem-4',
                order: 3,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-sem-curr-plan',
                        type: 'weekly_current',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {
                            pageSize: 12,
                            pageIndex: 0,
                        },
                    },
                ],
            },
            // Slide 5: Avance Gráfico Actual (Proyección física en plano)
            {
                id: 's-sem-5',
                order: 4,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-sem-curr-graphic',
                        type: 'graphic_progress_current',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'master-tpl-intermedia',
        projectId: 'global',
        name: 'Reunión de Planificación Intermedia (Lookahead)',
        description: 'Plantilla de control de mediano plazo (3 a 6 semanas): Carta Gantt maestra, identificación temprana de restricciones y seguimiento de hitos contractuales.',
        category: 'intermedia',
        isDefault: true,
        createdBy: 'ConstructOS / Administración',
        createdAt: '2026-01-01T00:00:00.000Z',
        updatedAt: '2026-01-01T00:00:00.000Z',
        slides: [
            // Slide 1: Portada Lookahead
            {
                id: 's-int-1',
                order: 0,
                background: '#0f172a',
                widgets: [
                    {
                        id: 'w-int-title',
                        type: 'text_block',
                        x: 5,
                        y: 20,
                        width: 90,
                        height: 25,
                        config: {
                            text: 'PLANIFICACIÓN INTERMEDIA & LOOKAHEAD',
                            fontSize: 34,
                            fontWeight: 800,
                            color: '#ffffff',
                            textAlign: 'center',
                            subtitle: 'Análisis de Restricciones, Hitos Contractuales y Flujo de Procesos',
                        },
                    },
                    {
                        id: 'w-int-milestones',
                        type: 'milestones',
                        x: 15,
                        y: 52,
                        width: 70,
                        height: 38,
                        config: {},
                    },
                ],
            },
            // Slide 2: Carta Gantt y Ventana de Lookahead
            {
                id: 's-int-2',
                order: 1,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-int-gantt',
                        type: 'gantt_master',
                        x: 3,
                        y: 5,
                        width: 94,
                        height: 90,
                        config: {},
                    },
                ],
            },
            // Slide 3: Detalle de Planificación Intermedia
            {
                id: 's-int-3',
                order: 2,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-int-lookahead',
                        type: 'lookahead',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'master-tpl-gerencial',
        projectId: 'global',
        name: 'Reunión Gerencial de Proyecto',
        description: 'Plantilla de alta dirección con indicadores ejecutivos (Curva S, PPC, Causas de No Cumplimiento Pareto) y resumen de avance físico en plano.',
        category: 'gerencial',
        isDefault: true,
        createdBy: 'ConstructOS / Administración',
        createdAt: '2026-01-01T00:00:00.000Z',
        updatedAt: '2026-01-01T00:00:00.000Z',
        slides: [
            // Slide 1: Portada y KPIs Clave
            {
                id: 's-ger-1',
                order: 0,
                background: '#0f172a',
                widgets: [
                    {
                        id: 'w-ger-title',
                        type: 'text_block',
                        x: 5,
                        y: 18,
                        width: 90,
                        height: 25,
                        config: {
                            text: 'INFORME GERENCIAL DE ESTADO DE PROYECTO',
                            fontSize: 34,
                            fontWeight: 800,
                            color: '#ffffff',
                            textAlign: 'center',
                            subtitle: 'Control de Producción, Cumplimiento de Plazos y Gestión de Rendimientos',
                        },
                    },
                    {
                        id: 'w-ger-kpis',
                        type: 'kpi_cards',
                        x: 10,
                        y: 50,
                        width: 80,
                        height: 38,
                        config: {},
                    },
                ],
            },
            // Slide 2: Evolución PPC y Análisis de Causas de No Cumplimiento
            {
                id: 's-ger-2',
                order: 1,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-ger-ppc',
                        type: 'ppc_evolution',
                        x: 4,
                        y: 5,
                        width: 44,
                        height: 88,
                        config: {},
                    },
                    {
                        id: 'w-ger-pareto',
                        type: 'pareto_chart',
                        x: 51,
                        y: 5,
                        width: 45,
                        height: 88,
                        config: {},
                    },
                ],
            },
            // Slide 3: Avance Gráfico General
            {
                id: 's-ger-3',
                order: 2,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-ger-graphic',
                        type: 'graphic_progress_current',
                        x: 4,
                        y: 5,
                        width: 92,
                        height: 90,
                        config: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'master-tpl-calidad',
        projectId: 'global',
        name: 'Reunión de Calidad y Subcontratos',
        description: 'Plantilla de aseguramiento de calidad con estado de protocolos de inspección, semáforos de cumplimiento por especialidad y evaluación de contratistas.',
        category: 'calidad',
        isDefault: true,
        createdBy: 'ConstructOS / Administración',
        createdAt: '2026-01-01T00:00:00.000Z',
        updatedAt: '2026-01-01T00:00:00.000Z',
        slides: [
            // Slide 1: Portada Calidad
            {
                id: 's-cal-1',
                order: 0,
                background: '#0f172a',
                widgets: [
                    {
                        id: 'w-cal-title',
                        type: 'text_block',
                        x: 5,
                        y: 20,
                        width: 90,
                        height: 25,
                        config: {
                            text: 'COMITÉ DE CALIDAD Y SUBCONTRATOS',
                            fontSize: 34,
                            fontWeight: 800,
                            color: '#ffffff',
                            textAlign: 'center',
                            subtitle: 'Inspección de Obras, Liberación de Protocolos y Calificación de Proveedores',
                        },
                    },
                    {
                        id: 'w-cal-sem',
                        type: 'compliance_semaphore',
                        x: 20,
                        y: 52,
                        width: 60,
                        height: 35,
                        config: {},
                    },
                ],
            },
            // Slide 2: Resumen de Protocolos & Evaluaciones SC
            {
                id: 's-cal-2',
                order: 1,
                background: '#ffffff',
                widgets: [
                    {
                        id: 'w-cal-prot',
                        type: 'protocol_summary',
                        x: 4,
                        y: 5,
                        width: 45,
                        height: 88,
                        config: {},
                    },
                    {
                        id: 'w-cal-eval',
                        type: 'sc_evaluations',
                        x: 51,
                        y: 5,
                        width: 45,
                        height: 88,
                        config: {},
                    },
                ],
            },
        ],
    },
];
